import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../auth/auth-state.service';

/**
 * Admin Panel / Audit routes — any authenticated organisation admin.
 * (Publish/rollback stay gated separately via isITStaff / staff tenant.)
 */
export const adminGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (!authState.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  const role = (authState.userRole() || '').toLowerCase();
  if (role === 'admin') {
    return true;
  }

  return router.createUrlTree(['/app/smartfreight/rates']);
};

/**
 * Flags inbox — any signed-in app user (admin, publisher, analyst, auditor, …).
 * List scope is enforced by GET /api/flags; Mark complete stays Irish Taylor staff only.
 */
export const flagsInboxGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (auth.isAuthenticated() && (auth.userRole() || '').trim()) {
    return true;
  }
  return router.createUrlTree(['/login']);
};

/** @deprecated Prefer flagsInboxGuard — kept so older imports keep compiling. */
export const itStaffAdminGuard = flagsInboxGuard;
